import { render, staticRenderFns } from "./NoPrizeModal.vue?vue&type=template&id=217aaee1"
import script from "./NoPrizeModal.vue?vue&type=script&lang=js"
export * from "./NoPrizeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports